module.exports = "/_next/static/images/first-home_signup-desktop-ef351e43f1be62f0a48ecf05c4eb31e4.svg";